export const categoryMap = {
    avatar: 1, // 头像框
    subtitles: 2, // 弹幕框
    video: 3, // 视频框
    gift: 4 // 实物奖励
};